import { useDispatch, useSelector } from 'react-redux';
import FirmNavnId from '../../../models/FirmNavnId';
import TTReportItem from '../../../models/payload/TTReportItem';
import { TaleSearchParams } from '../../../models/TalenesTale';
import * as actions from '../../../store/actions/index';
import { AppState } from '../../../store/rootReducer';
import SalgsstatistikkTable from './SalgsstatistikkTable';

const TallenesTaleListKunde = () => {
  const dispatch = useDispatch();
  const salesReport: TTReportItem[] = useSelector((state) => (state as AppState).tallenesTale.salesReportKunde);
  const taleSearch: TaleSearchParams = useSelector((state) => (state as AppState).tallenesTale.taleSearchKunde);
  const selectedSubKunde: FirmNavnId = useSelector((state) => (state as AppState).tallenesTale.selectedSubKunde);

  // Clicking a customer selects it as "sub-kunde" for the other visninger (and Rådata); clicking it again clears it.
  const selectCustomer = (r: TTReportItem) => {
    if (r.id === selectedSubKunde?.firmID.toString()) {
      dispatch(actions.setSelectedSubKunde(new FirmNavnId(0, '')));
    } else {
      dispatch(actions.setSelectedSubKunde(new FirmNavnId(parseInt(r.id), r.name, 0, '')));
    }
    dispatch(actions.setResetSalesReport());
  };

  return (
    <SalgsstatistikkTable visning="Kunde" rows={salesReport ?? []} taleSearch={taleSearch}
      idLabel="Kunde Id." nameLabel="Kundenavn" onRowClick={selectCustomer} selectedId={selectedSubKunde?.firmID.toString()}
      title={taleSearch ? 'Salgsstatistikk etter kunde, ' + taleSearch.butikk + (selectedSubKunde?.firmID > 0 ? ', ' + selectedSubKunde.firmName : '') : null} />
  );
};

export default TallenesTaleListKunde;
